// ... existing code ...

const ProcessBar = ({ currentPage, totalPages, onPageClick }) => {
  // 페이지 이름 매핑
  const getPageName = (pageNumber) => {
    switch (pageNumber) {
      case 1:
        return "병원 전 단계";
      case 2:
        return "응급실";
      case 3:
        return "입원 후";
      case 4:
        return "Pupil";
      default:
        return `Page ${pageNumber}`;
    }
  };

  return (
    <div className="process-bar">
      {Array.from({ length: totalPages }, (_, index) => {
        const pageNumber = index + 1;
        return (
          <div
            key={pageNumber}
            className={`process-step ${
              currentPage === pageNumber ? "active" : ""
            }`}
            onClick={() => onPageClick(pageNumber)}
          >
            <div className="step-circle">{pageNumber}</div>
            <div className="step-label">{getPageName(pageNumber)}</div>
          </div>
        );
      })}
    </div>
  );
};

export default ProcessBar;
